<template>
  <div>
    <div v-if="anyUserOrganizationAvailable">
      <div>
        <div class="chip-container">
          <v-chip
            dark
            rounded
            color="#FFF"
            small
            elevation="0"
            @click="showFilterForm = true"
          >
            <v-icon
              small
              dark
            >
              mdi-filter
            </v-icon>&nbsp; {{ isDateRange }}
          </v-chip>
          <v-btn
            dark
            outlined
            icon
            color="#37474F"
            small
            @click="fetchAllUserActivities"
          >
            <v-icon
              small
              dark
            >
              mdi-filter-off
            </v-icon>
          </v-btn>
        </div>
      </div>
      <br>
      <div
        v-if="isActivityRecordsAvailable"
        class="user-activity"
      >
        <v-card
          v-for="(item, index) in userActivities"
          :key="index"
          color="#FFF"
          elevation="0"
          class="container"
        >
          <div class="container-box mb-3">
            <v-card-text>
              <div class="box">
                <div class="d-flex justify-space-between">
                  <p class="title-text-style">
                    Project :
                    <font class="value-text-style">
                      {{ item.project.name }}
                    </font>
                  </p>
                  <v-chip
                    v-if="item.total_hours !== null"
                    dark
                    rounded
                    outlined
                    color="#e6e6e6"
                    x-small
                    elevation="0"
                    class="pr-3"
                  >
                    <v-icon x-small>
                      mdi-account-clock
                    </v-icon>&nbsp;
                    {{ item.total_hours }} Hrs
                  </v-chip>
                </div>

                <p class="title-text-style pt-3">
                  Type:
                  <font class="value-text-style capitalizeFirstLetter">
                    {{ item.type | arrangePretty }}
                  </font>
                </p>
                <div class="time-style">
                  <p>
                    <v-icon
                      color="green"
                      size="18"
                    >
                      mdi-update
                    </v-icon>
                    <font
                      class="value-text-style"
                      style="text-transform: uppercase"
                    >
                      {{ item.checkin_time | convertToLocal }}
                    </font>
                  </p>
                  <p v-if="item.checkout_time !== null">
                    <v-icon
                      color="red"
                      size="18"
                    >
                      mdi-history
                    </v-icon>
                    <font
                      class="value-text-style"
                      style="text-transform: uppercase"
                    >
                      {{ item.checkout_time | convertToLocal }}
                    </font>
                  </p>
                  <p v-else>
                    <v-icon
                      color="red"
                      size="18"
                    >
                      mdi-history
                    </v-icon>
                    <font class="value-text-style active-color">
                      Onsite*
                    </font>
                  </p>
                </div>
              </div>
            </v-card-text>
          </div>
        </v-card>
        <div
          ref="observer"
          class="observer"
        />
        <div class="text-center">
          <v-progress-circular
            v-if="lazyLoader"
            size="25"
            :width="1"
            color="#E2E2E2"
            indeterminate
          />
        </div>
      </div>
      <div
        v-else
        class="empty-alert-div"
      >
        <v-card
          color="#FFF"
          elevation="0"
        >
          <br>
          <br>
          <p class="empty-alert-msg">
            <v-icon
              size="25"
              color="#C62828"
            >
              mdi-information-outline
            </v-icon>
            No records found
          </p>
          <br>
          <br>
        </v-card>
      </div>
      <div class="py-3" />
      <centre-spinner :loading="loading" />
      <filter-user-activities
        v-if="showFilterForm"
        @selectedTime="handleSelectedTime"
        @closed="showFilterForm = false"
      />
    </div>
    <div
      v-else
      class="empty-alert-div"
    >
      <v-card
        color="#FFF"
        elevation="0"
      >
        <br>
        <br>
        <p class="empty-alert-msg">
          <v-icon
            size="25"
            color="#C62828"
          >
            mdi-information-outline
          </v-icon>
          No Organizations Found
        </p>
        <br>
        <br>
      </v-card>
    </div>
  </div>
</template>
<script>
import spinner from 'src/views/components/SpinnerCentre';
import moment from 'moment';
import FilterUserActivities from './FilterUserActivities.vue';

export default {
  name: 'UserActivity',
  components: {
    'centre-spinner': spinner,
    'filter-user-activities': FilterUserActivities,
  },
  filters: {
    convertToLocal (stringDatetime) {
      return moment(stringDatetime).local().format('DD-MM-YYYY hh:mm a');
    },
    displayHighRisk (status) {
      if (status === true) {
        return 'Yes*';
      } else {
        return 'No';
      }
    },
    capitalizeFirstLetter (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    arrangePretty (val) {
      if (val === 'staff') {
        return 'Site Manager';
      } else {
        return val;
      }
    },
  },
  data () {
    return {
      search: '',
      loading: false,
      showForm: false,
      startPage: 0,
      observer: null,
      showFilterForm: false,
      fromDate: null,
      toDate: null,
      lazyLoader: false,
    };
  },
  computed: {
    userActivities () {
      const list = this.$store.getters['userprofile/getUserActivities'];
      const sortedList = list.sort((a, b) => {
        return new Date(b.created_at) - new Date(a.created_at);
      });
      return sortedList;
    },
    userOrganizations () {
      return this.$store.getters['organization/getUserOrganizations'];
    },
    anyUserOrganizationAvailable () {
      if (this.userOrganizations.length === 0) {
        return false;
      }
      return true;
    },
    isDateRange () {
      if (this.fromDate && this.toDate) {
        return `${moment
          .utc(this.fromDate)
          .local()
          .format('DD-MM-YYYY')}  -  ${moment
          .utc(this.toDate)
          .local()
          .format('DD-MM-YYYY')}`;
      } else {
        return 'Till Today';
      }
    },
    isActivityRecordsAvailable () {
      if (this.userActivities.length !== 0) {
        return true;
      }
      return false;
    },
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
  },
  async mounted () {
    this.loading = true;
    await this.clearPreviousData();
    await this.getUserOrganizations();
    this.anyUserOrganizationAvailable && (await this.fetchUserActivities());
    await this.loadMore();
    this.loading = false;
  },
  methods: {
    async fetchUserActivities () {
      this.lazyLoader = true;
      await this.$store.dispatch('userprofile/fetchUserActivities', {
        params: {
          params: {
            organizationId: this.selectedOrganization.organization.external_id,
            from: this.fromDate,
            to: this.toDate,
            startPage: this.startPage,
            limit: 5,
          },
        },
      });
      this.lazyLoader = false;
    },
    async getUserOrganizations () {
      this.startPage = 0;
      await this.$store.dispatch('organization/fetchUserOrganizations', {
        params: {
          requestStatus: 'accepted',
        },
      });
    },
    handleSelectedTime (time) {
      this.fromDate = time.checkInTime;
      this.toDate = time.checkOutTime;
      this.startPage = 0;
      this.loadMore();
    },
    async fetchAllUserActivities () {
      this.loading = true;
      this.startPage = 0;
      this.fromDate = null;
      this.toDate = null;
      await this.$store.dispatch('userprofile/clearUserActivities');
      await this.fetchUserActivities();
      await this.loadMore();
      this.loading = false;
    },
    async loadMore () {
      if (this.userActivities.length === 0) {
        return;
      }
      await this.initObserver();
    },
    initObserver () {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5,
      };
      this.observer = new IntersectionObserver(this.handleIntersect, options);
      this.observer.observe(this.$refs.observer);
    },
    handleIntersect (entries) {
      if (entries[0].isIntersecting) {
        this.startPage += 5;
        this.fetchUserActivities();
      }
    },
    clearPreviousData () {
      this.$store.dispatch('userprofile/clearUserActivities');
    },
  },
};
</script>
<style scoped>
.container {
  border-radius: 10px !important;
  padding: 0px !important;
}

.user-activity {
  margin-bottom: 40px !important;
}

.time-style {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 6px;
}

p {
  margin-bottom: 0px !important;
}

.title-text-style,
.value-text-style {
  font-size: 14px;
}

.time-style .value-text-style {
  font-size: 12px;
}

.container-box {
  width: 100% !important;
  border-radius: 10px;
}

.box {
  width: 100% !important;
}

.theme--dark.v-list {
  background-color: white !important;
}

.theme--dark >>> .v-list-item {
  color: #37474f !important;
}

.chip-container {
  display: flex;
  justify-content: space-between;
}

.active-color {
  color: #2e7d32;
}

.observer {
  height: 40px;
}

.capitalizeFirstLetter {
  text-transform: capitalize;
}
.v-chip.v-size--small {
  height: 28px !important;
}
</style>
